import Personnummer from 'personnummer'
import type { Person } from 'shared-types'

export const ssnValidOrHasBirthDate = (value: string, siblings: Person) => {
  /** Requires that the ssn is either valid or that there is a birthDate */
  if (!value) return !!siblings.birthDate
  if (Personnummer.valid(value)) return true
  return false
}

export const ssnValid = (value: string) => {
  if (Personnummer.valid(value)) return true
  return false
}
